import { Inject, Injectable, Optional } from '@angular/core';
import {Meta, MetaDefinition, Title} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { REQ_URL } from './tokens/req-url';

export interface PageMetadata {
  title: string;
  image: string;
  description: string;
  author: string;
  keywords: string[];
  type: string;
}

const defaultMetadata: PageMetadata = {
  title: '',
  image: '',
  description: '',
  author: '',
  keywords: [],
  type: 'website',
};

@Injectable()
export class MetadataService {
  constructor(private metaTagService: Meta,
              private titleService: Title,
              private router: Router,
              @Optional() @Inject(REQ_URL) private reqUrl: string,
              ) {}

              
  public updateMetadata(metadata: Partial<PageMetadata>, index: boolean = true): void {
    const pageMetadata: PageMetadata = {...defaultMetadata, ...metadata};
    const metatags: MetaDefinition[] = this.generateMetaDefinitions(pageMetadata);

    if(!this.reqUrl){
      this.reqUrl = window.location.href;
    }
    var url = new URL(this.reqUrl);

    this.metaTagService.addTags([
     ...metatags,
     { property: 'og:url', content: `${url.origin}${this.router.url}`},
     { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
     //{ name: 'robots', content: index ? 'index, follow' : 'noindex' },
     //{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ], false);

    this.titleService.setTitle(pageMetadata.title);
  }

  private generateMetaDefinitions(metadata: PageMetadata): MetaDefinition[] {
    return [
      { name: 'title', content: metadata.title },
      { property: 'og:title', content: metadata.title },

      { name: 'description', content: metadata.description },
      { property: 'og:description', content: metadata.description },

      { name: 'author', content: metadata.author },
      { property: 'og:author', content: metadata.author },

      { name: 'keywords', content: metadata.keywords.join(', ') },

      { property: 'og:type', content: metadata.type },

      { property: 'og:image', content: metadata.image }
    ];
  }
}